export default "__VITE_ASSET__b04926b9__"